// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"aad046b0","507":"c0d6ed9f","837":"9e9bce1e"}[chunkId] + ".chunk.js";
};